import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IVatType extends IBaseEntity {
    id?: number;
    name?: string;
    accountsPackageCode?: string;
    rates?: any[];
    currentRate?: number;
}

export class VatType extends BaseEntity implements IVatType {
    public id?: number;
    public name?: string;
    public accountsPackageCode?: string;
    public rates?: any[];
    public currentRate?: number;

    constructor(type?: any) {
        super();
        if (type) {
            this.id = type.id;
            this.name = type.name;
            this.accountsPackageCode = type.accountsPackageCode;
            this.rates = type.rates;
            this.currentRate = type.currentRate;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): VatType {
        return new VatType(this);
    }
}
